import { Box, Tooltip, Typography } from "@mui/material";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { SessionInfo } from "./listTypes";
import { formatTime, getShortWeekDayLabel } from "./listHelpers";

type SessionCellContentProps = {
    nfbSession: SessionInfo | undefined;
    psySession: SessionInfo | undefined;
    showNfb: boolean;
};

export const SessionCellContent = ({ nfbSession, psySession, showNfb }: SessionCellContentProps) => {
    const cellHeight = showNfb ? 28 : 44;

    const renderSessionIcon = (session: SessionInfo | undefined) => {
        if (!session) {
            return <Typography variant="caption" color="text.disabled">-</Typography>;
        }

        if (session.matches) {
            return <CheckCircle sx={{ fontSize: 20, color: "#2e7d32" }} />;
        }

        const weekDayLabel = getShortWeekDayLabel(session.weekDay);
        const isBypassed = Boolean(session.bypassedWarningReason);
        const iconColor = isBypassed ? "#ed6c02" : "#c62828";


        const tooltipText = isBypassed
            ? `Agendado: ${weekDayLabel} ${formatTime(session.time)} (${session.bypassedWarningReason})`
            : `Agendado: ${weekDayLabel} ${formatTime(session.time)}`;

        return (
            <Tooltip title={tooltipText} arrow>
                <Cancel sx={{ fontSize: 20, color: iconColor, cursor: "help" }} />
            </Tooltip>
        );
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {showNfb && (
                <Box
                    sx={{
                        height: cellHeight,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderBottom: "1px solid #e0e0e0",
                    }}
                >
                    {renderSessionIcon(nfbSession)}
                </Box>
            )}
            <Box
                sx={{
                    height: cellHeight,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {renderSessionIcon(psySession)}
            </Box>
        </Box>
    );
};

